<template>
  <div class="demo-guide" @mouseleave.stop="handle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DemoGuideStep",
  props: {
    handleMouseLeave: {
      type: Function,
      required: false,
      default: () => false
    }
  },
  methods: {
    handle() {
      this.handleMouseLeave(null);
    }
  }
};
</script>

<style scoped>
.demo-guide {
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>
